import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import {sitekey} from "../utilities/config"

const Captcha = (props) => {
    return (
        <div>
        <ReCAPTCHA 
            sitekey={sitekey}
            onChange={props.onCaptchaChange}
        />
        {props.captchaError && <p style={{color:"red",fontSize:10}}>Please verify the Captcha</p>}
        </div>
    );
}

export default Captcha;